import { Phrases } from '@shared/models/locales.model';

export default {
  'Buttons.Cancel': 'Cancel',
  'Buttons.Save': 'Save',
  'Buttons.Next': 'Next',
  'Buttons.SelectFile': 'Select File',
  'Buttons.Confirm': 'Confirm',
  'Buttons.Find': 'Find',
  'Buttons.Download': 'Download',
  'Placeholder.EnterReason': 'Enter your reason...',

  components: {
    sortMenu: {
      MostRecent: 'Most Recent',
      NameAZ: 'Low to High',
      NameZA: 'High to Low',
      sort: 'Sort',
      HighNoOfPallets: 'high No.Of Pallets',
      LowNoOfPallets: 'low No. Of Pallets',
      ALL: 'ALL',
      AMB: 'AMB',
      Chiller: 'Chiller',
      Frozen: 'Frozen',
      Deep_Frozen: 'Deep Frozen',
    },
    activity: {
      theInvoice: 'the invoice.',
      successfully: 'The invoice has been paid successfully.',
      activity: 'Activity',
      Converted: 'Converted The Invoice to Over Due',
      system: 'Madar',
    },
    confirmation: {
      cancelTitle: 'Confirm cancel!',
      cancelText: 'Are you sure you want to cancel this? All filled data will permanently removed and cannot be undone.',
      cancelDiscard: 'No, Keep it',
      cancelConfirm: 'Yes, Cancel',
      discard: 'discard',
      confirm: 'confirm',
      cancel: 'cancel',
    },
    changeLanguage: 'Change Language',

    lazyDropdown: {
      all: 'All {{items}}',
      addNew: 'Add new',
    },
  },

  Errors: {
    NetworkError: 'Network Disconnected, please check your connection and reload the app again!.',
  },
  accordion: {
    OrderID: 'Order ID:',
    Pallet: 'Pallet',
    Items: 'Items',
    All: 'All',
    Orders: 'Orders',
    SealNo: 'Seal No',
    ProofOfDelivery: 'Proof of delivery',
    Download: 'Download',
  },
  Enum: {
    OrderType: {
      StockToCustomerStock: 'Stock Transfer',
      StoTransfer: 'Stock Transfer',
      Z122: 'Stock Transfer',
      CustomerOutboundOrders: 'Outbound Transfer',
      CustomerReturn: 'Customer Return',
      CustomerReturnNupcoStock: 'Customer Return Nupco Stock',
      NupcoSalesReturns: 'Nupco Sales Returns',
      DistributionOutboundOrder: 'Distribution Outbound Order',
      TransferOrders: 'Transfer Orders',
      VendorSupplierReturns: 'Vendor Supplier Returns',
      SalesOrder: 'Sales Order',
      NupcoRoyalCourt: 'Nupco Royal Court',
      NupcoDonationIssue: 'Nupco Donation Issue',
      ScrapOrders: 'Scrap Orders',
      PrepareOrder: 'Prepare Order',
      SalesWithPrice: 'Sales With Price',
      ZPG1: 'ZPG1',
      MOIR: 'MOI-R',
    },
    InvoiceAction: {
      CREATED: 'Created',
      UPDATED: 'Updated',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      PAID: 'Paid',
    },
    WccIntegrationStatusType: {
      WAITING_ASSIGNMENT: 'Waiting Assignment',
      INTEGRATED: 'Integrated',
      INTEGRATION_FAILED: 'Integration Failed',
      INTEGRATION_IN_PROGRESS: 'Integration in Progress',
      INTEGRATION_CANCELED: 'Integration canceled',
      CANCELATION_FAILED: 'Integration failed',
    },
  },
  shipmentSummary: {
    totalDistance: 'Total Distance',
  },
  km: 'KM',
  hrs: 'hrs',
  min: 'min',
  AutoCache: 'Auto Cache',

  'currency.SAR': 'SAR',
  'currency.EGP': 'EGP',
  'Validation.required': '{{field}} is required!',
  'Validation.realNumberValidator': '{{field}} only Number!',
  'Validation.min': '{{field}} should be {{min}} or more!',
  'Validation.max': '{{field}} should be {{max}} or less!',
  'Validation.minLength': '{{field}} should be at least {{minLength}} characters!',
  'Validation.minlength': '{{field}} should be at most {{maxLength}} characters!',
  'Validation.duplicated': '{{field}} is duplicated!',
  'Validation.maxLength': '{{field}} should be at most {{maxLength}} characters!',
  'Validation.maxlength': '{{field}} should be at most {{maxLength}} characters!',
  'Validation.pastDate': 'Date and time must be in the future.',
  'Validation.invalidPhoneNumberLength': 'Invalid Phone Number Length',
  'cardItemsList.Orders': 'الطلبات',
  'cardItemsList.Pallet': 'باليت',
  'cardItemsList.Items': 'عناصر',
  'cardItemsList.PalletItems': 'عناصر البالتة',
  'cardItemsList.LineItems': 'Line Items',
  'cardItemsList.NoPalletSelected': 'لم يتم تحديد أي باليت',
  'cardItemsList.OnceYouSelectTheDetailsWillAppearHere': 'بمجرد تحديدك، ستظهر التفاصيل هنا',
  'cardItemsList.Qty': 'الكمية',
  'cardItemsList.Accepted': 'مقبول',
  'cardItemsList.Returned': 'مرتجع',
  'cardItemsList.Batch': 'الدفعة',
  'cardItemsList.EmptyPalletHint': 'عندما تقوم بالاختيار ستظهر التفاصيل هنا.',
  'announcementBar.news': 'News',
  'announcementBar.link': 'Link',
  Important: 'Important!',
  CompleteYourInformation:
    'Complete your Informations for trusted shipments with certified partners, official invoicing, and real-time tracking.',
  CompleteInformation: 'Complete My Information',
  Platform: 'logistic Marketplace',
} as Phrases;
